import React from "react";
import Map from "../Map/Map";
import "./StationMap.less";
import { stations } from "pages/stations/utils/types";

type Props = {
  data: stations[];
  stationData?: any;
};

const StationMap = ({ data, stationData }: Props) => {
	return (
		<section className="station-map-container">
			<div className="station-map">
				<Map markers={data} stationData={stationData}></Map>
			</div>
		</section>
	);
};

export default StationMap;
